var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 302,
    viewBox: "0 0 217 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 215.802,
    y2: 1,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 93.5927,
    x2: 215.802,
    y2: 93.5927,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 186.185,
    x2: 215.802,
    y2: 186.185,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 47.2961,
    x2: 215.802,
    y2: 47.2961,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 139.889,
    x2: 215.802,
    y2: 139.889,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 232.482,
    x2: 215.802,
    y2: 232.482,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 277.852,
    x2: 215.802,
    y2: 277.852,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 24.1482,
    x2: 215.802,
    y2: 24.1482,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 116.741,
    x2: 215.802,
    y2: 116.741,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 209.333,
    x2: 215.802,
    y2: 209.333,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 70.4446,
    x2: 215.802,
    y2: 70.4446,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 163.037,
    x2: 215.802,
    y2: 163.037,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 255.63,
    x2: 215.802,
    y2: 255.63,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 301,
    x2: 215.802,
    y2: 301,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupline);
export default __webpack_public_path__ + "static/media/groupline.1d30b191675161207fa298faeabcfa6f.svg";
export { ForwardRef as ReactComponent };